import { authSplitApi } from 'redux/helpers/slice.helpers';
import { EDocPacketUrls } from 'data/urls/docPacket.url';
import { TFile } from 'data/types/Storage.types';
import {
  TDocPacketUI,
  TDocPacketGetUI,
  TNameUpdateUI,
  TPhoneUpdateUI,
  TEmailUpdateUI,
  TFaxUpdateUI,
  THPVisitationUpdateUI,
  TDocPacketGet,
  THPLetterUpdateUI,
  THPFormUpdateUI,
  THPDocResponse,
} from 'data/types/DocPacket.types';
import {
  createHPDocConvertor,
  hpNameUpdateConvertor,
  hpEmailUpdateConvertor,
  hpFaxUpdateConvertor,
  hpPhoneUpdateConvertor,
  hpVisitationUpdateConvertor,
  getHPDocPacketsConvertor,
  hpLetterUpdateConvertor,
  hpFormUpdateConvertor,
} from 'data/convertors/DocPacket.convertors';

const baseUrl = `${EDocPacketUrls.TENANT}/${EDocPacketUrls.HP_DOCUMENT_PACKET}`;

export const DocPacketApi = authSplitApi('DocPacket', [
  'DocPacket',
  'DocPackets',
]).injectEndpoints({
  endpoints: build => ({
    createHPDocPacket: build.mutation<void, TDocPacketUI>({
      query(body) {
        return {
          url: baseUrl,
          method: 'POST',
          body: createHPDocConvertor.toDb(body),
        };
      },
      invalidatesTags: ['DocPackets'],
    }),
    getHPDocPackets: build.query<TDocPacketGetUI[], void>({
      query() {
        return {
          url: baseUrl,
          method: 'GET',
        };
      },
      transformResponse: (data: TDocPacketGet[]) =>
        data.map(item => getHPDocPacketsConvertor.fromDb(item)),
      providesTags: ['DocPackets'],
    }),
    updateHPName: build.mutation<void, TNameUpdateUI>({
      query(data) {
        return {
          url: `${baseUrl}/${EDocPacketUrls.HP_CONTACT}/${EDocPacketUrls.NAME}`,
          method: 'PATCH',
          body: hpNameUpdateConvertor.toDb(data),
        };
      },
      invalidatesTags: ['DocPackets'],
    }),
    updateHPPhone: build.mutation<void, TPhoneUpdateUI>({
      query(data) {
        return {
          url: `${baseUrl}/${EDocPacketUrls.HP_CONTACT}/${EDocPacketUrls.PHONE}`,
          method: 'PATCH',
          body: hpPhoneUpdateConvertor.toDb(data),
        };
      },
      invalidatesTags: ['DocPackets'],
    }),
    updateHPEmail: build.mutation<void, TEmailUpdateUI>({
      query(data) {
        return {
          url: `${baseUrl}/${EDocPacketUrls.HP_CONTACT}/${EDocPacketUrls.EMAIL}`,
          method: 'PATCH',
          body: hpEmailUpdateConvertor.toDb(data),
        };
      },
      invalidatesTags: ['DocPackets'],
    }),
    updateHPFax: build.mutation<void, TFaxUpdateUI>({
      query(data) {
        return {
          url: `${baseUrl}/${EDocPacketUrls.HP_CONTACT}/${EDocPacketUrls.FAX_NUMBER}`,
          method: 'PATCH',
          body: hpFaxUpdateConvertor.toDb(data),
        };
      },
      invalidatesTags: ['DocPackets'],
    }),
    updateHPVisitation: build.mutation<void, THPVisitationUpdateUI>({
      query(data) {
        return {
          url: `${baseUrl}/${EDocPacketUrls.HP_VISITATION}`,
          method: 'PATCH',
          body: hpVisitationUpdateConvertor.toDb(data),
        };
      },
      invalidatesTags: ['DocPackets'],
    }),
    updateHPLetter: build.mutation<void, THPLetterUpdateUI>({
      query(data) {
        return {
          url: `${baseUrl}/${EDocPacketUrls.HP_LETTER}`,
          method: 'PATCH',
          body: hpLetterUpdateConvertor.toDb(data),
        };
      },
      invalidatesTags: ['DocPackets'],
    }),
    updateHPForm: build.mutation<void, THPFormUpdateUI>({
      query(data) {
        return {
          url: `${baseUrl}/${EDocPacketUrls.HP_FORM}`,
          method: 'PATCH',
          body: hpFormUpdateConvertor.toDb(data),
        };
      },
      invalidatesTags: ['DocPackets'],
    }),
    deleteHPDocPacket: build.mutation<void, string>({
      query(documentPacketId) {
        return {
          url: `${baseUrl}`,
          method: 'DELETE',
          body: { documentPacketId },
        };
      },
      invalidatesTags: ['DocPackets'],
    }), 
  }),
});

export const {
  useCreateHPDocPacketMutation,
  useGetHPDocPacketsQuery,
  useUpdateHPEmailMutation,
  useUpdateHPFaxMutation,
  useUpdateHPNameMutation,
  useUpdateHPPhoneMutation,
  useUpdateHPVisitationMutation,
  useDeleteHPDocPacketMutation,
  useUpdateHPLetterMutation,
  useUpdateHPFormMutation, 
} = DocPacketApi;
